import {isDevEnv, isSelectiveAiDomains} from 'common/HelperFunctions'
import {BUILD_VERSION} from 'common/constants'
import {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {shallowEqual, useSelector} from 'react-redux'
import {Link} from 'react-router'
import {RootState} from 'setup'

import {ILayout, useLayout} from '../../core'

const Footer = () => {
  const {config} = useLayout()
  const intl = useIntl()
  const isAiSelectiveDomain = isSelectiveAiDomains()
  const generalSettings = useSelector<RootState>(
    ({mainReducer}) => mainReducer.generalSettings,
    shallowEqual
  ) as any

  const footerPoweredByText =
    typeof generalSettings?.powered_by_text === 'string'
      ? isAiSelectiveDomain
        ? generalSettings.powered_by_text.replace(/ilmversity/gi, 'Da1Timetable')
        : generalSettings.powered_by_text
      : generalSettings?.powered_by_text

  useEffect(() => {
    updateDOM(config)
  }, [config])
  return (
    <>
      <div className='text-dark order-2 order-md-1'>
        {!generalSettings?.powered_by_text && (
          <>
            <span className='text-muted fw-bold me-2'>{new Date().getFullYear()} &copy;</span>
            <a
              href='https://ilmversity.com'
              className='text-gray-800 text-hover-primary me-1'
              target='_blank'
              rel='noreferrer'
            >
              {isAiSelectiveDomain ? 'Da1Timetable' : 'Ilmversity'}
            </a>
          </>
        )}
        {!!footerPoweredByText && (
          <span className='me-1' dangerouslySetInnerHTML={{__html: footerPoweredByText}} />
        )}
        | <Link to='/institute/change-log'>Build: {BUILD_VERSION}</Link>
      </div>

      {!generalSettings?.powered_by_text && (
        <ul className='menu menu-gray-600 menu-hover-primary fw-bold order-1'>
          {!isAiSelectiveDomain && (
            <>
              <li className='menu-item'>
                <a
                  href='https://ilmversity.com/about-us/'
                  target='_blank'
                  className='menu-link ps-0 pe-2'
                  rel='noreferrer'
                >
                  About
                </a>
              </li>
              <li className='menu-item'>
                <a
                  href='https://ilmversity.com/contact/'
                  target='_blank'
                  className='menu-link pe-2'
                  rel='noreferrer'
                >
                  Contact
                </a>
              </li>
            </>
          )}
          {/* Points at the in-app user manual, and rides on the same gate the
              manual's own sidebar entry uses, so the two never disagree. */}
          {isDevEnv() && !isAiSelectiveDomain && (
            <li className='menu-item'>
              <Link to='/user-manual' className='menu-link pe-2 text-primary'>
                <span className='fas fa-book-open me-1' />
                {intl.formatMessage({id: 'MENU.KNOWLEDGE_BASE'})}
              </Link>
            </li>
          )}
        </ul>
      )}
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
